import { RootState } from '@store/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import {
  GLOBAL_STATE,
  PRE_MODERATION_ALL,
  PRE_MODERATION_ASSIGNED,
  PRE_MODERATION_BY_ID,
  PRE_MODERATION_CHANGE_STATUS,
  PRE_MODERATION_HISTORY_CREATE,
} from '../constants/actionTypes'

const preModerationSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const preModerationAllSelector = createSelector(preModerationSelector, data => data[PRE_MODERATION_ALL])

export const preModerationAssignedSelector = createSelector(
  preModerationSelector,
  data => data[PRE_MODERATION_ASSIGNED]
)

export const preModerationByIdSelector = createSelector(preModerationSelector, data => data[PRE_MODERATION_BY_ID])

export const preModerationHistoryCreateSelector = createSelector(
  preModerationSelector,
  data => data[PRE_MODERATION_HISTORY_CREATE]
)

export const preModerationChangeStatusSelector = createSelector(
  preModerationSelector,
  data => data[PRE_MODERATION_CHANGE_STATUS]
)
